var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1765_13312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7306 12.8192C17.281 12.596 16.7356 12.7791 16.5119 13.2285C14.9186 16.4461 11.2164 18.0204 7.79366 16.9357C4.37095 15.851 2.25126 12.4316 2.8021 8.88364C3.35295 5.33567 6.40962 2.72 10.0001 2.72413C12.7674 2.71214 15.2975 4.28464 16.5119 6.77127C16.7379 7.22332 17.2876 7.40656 17.7397 7.18053C18.1917 6.9545 18.375 6.4048 18.1489 5.95274C16.2701 2.17171 12.0361 0.180941 7.92578 1.1459C3.81541 2.11086 0.909668 5.77776 0.909668 9.99988C0.909668 14.222 3.81541 17.8889 7.92578 18.8539C12.0361 19.8188 16.2701 17.8281 18.1489 14.047C18.2584 13.8291 18.2758 13.5763 18.1971 13.3454C18.1185 13.1146 17.9504 12.925 17.7306 12.8192ZM18.1853 9.09042H9.4635L11.5553 7.00773C11.786 6.77704 11.8761 6.44079 11.7916 6.12566C11.7072 5.81052 11.461 5.56438 11.1459 5.47994C10.8308 5.39549 10.4945 5.48559 10.2638 5.71629L6.62596 9.35417C6.54316 9.44066 6.47826 9.54265 6.43497 9.65429C6.34401 9.87571 6.34401 10.1241 6.43497 10.3455C6.47826 10.4571 6.54316 10.5591 6.62596 10.6456L10.2638 14.2835C10.4346 14.4557 10.6671 14.5525 10.9096 14.5525C11.1521 14.5525 11.3845 14.4557 11.5553 14.2835C11.7275 14.1127 11.8243 13.8803 11.8243 13.6378C11.8243 13.3953 11.7275 13.1628 11.5553 12.992L9.4635 10.9094H18.1853C18.6876 10.9094 19.0948 10.5022 19.0948 9.99989C19.0948 9.4976 18.6876 9.09042 18.1853 9.09042Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1765_13312)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5db874059c33d9a2ce9fe25946fa7b87.svg";
export { ForwardRef as ReactComponent };